import React, { Component } from "react";
import { Card, CardActionArea, CardContent, CircularProgress, Typography } from "@material-ui/core";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import Moment from "react-moment";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { compose } from "redux";
import * as actions from "../../../actions";
import { getContracts } from "../../../actions/Contract";
import { CardPageItem } from "../../../custom/Page";
import DarkBar from "../DarkBar";

class ContractsStatusOverview extends Component {
  state = {
    loading: true,
    contractsWaitingSign: [],
    contractsWaitingAport: [],
    contractsWaitingValidation: [],
    contractsWaitingFinalSign: [],
    contractsWaitingRedeem: [],
    contractsRedeemedWaitingPay: [],
    contractsRedeemedPaid: [],
    contractsActiveRecent: [],
    contractsExpiring: [],
  };

  componentDidMount() {
    const { currentUser } = this.props;

    Promise.all([
      getContracts({
        phase: "WAITING_SIGN",
        taxResidence: currentUser.taxResidence,
        consultantId: currentUser.id,
      }).then((data) => {
        this.setState({ contractsWaitingSign: data });
      }),

      getContracts({
        phase: "WAITING_APORT",
        taxResidence: currentUser.taxResidence,
        consultantId: currentUser.id,
      }).then((data) => {
        this.setState({ contractsWaitingAport: data.filter((c) => c.deposits.length === 0) });
        this.setState({ contractsWaitingValidation: data.filter((c) => c.deposits.length > 0) });
      }),

      getContracts({ phase: "VALIDATING", taxResidence: currentUser.taxResidence, consultantId: currentUser.id }).then((data) => {
        this.setState({ contractsWaitingFinalSign: data });
      }),

      getContracts({
        phase: "WAITING_WITHDRAW",
        taxResidence: currentUser.taxResidence,
        consultantId: currentUser.id,
      }).then((data) => {
        this.setState({ contractsWaitingRedeem: data });
      }),

      getContracts({
        statusRedeemPaid: "PAYMENT_GENERATED",
        taxResidence: currentUser.taxResidence,
        consultantId: currentUser.id,
      }).then((data) => {
        this.setState({ contractsRedeemedWaitingPay: data });
      }),

      getContracts({
        statusRedeemPaid: "PAID",
        taxResidence: currentUser.taxResidence,
        consultantId: currentUser.id,
      }).then((data) => {
        this.setState({
          contractsRedeemedPaid: data.filter((c) => moment().subtract(8, "days").isBefore(c.dueDate) && moment().subtract(8, "days").isBefore(c.archiveDate)),
        });
      }),

      getContracts({ status: "ACTIVE", taxResidence: currentUser.taxResidence, consultantId: currentUser.id }).then((data) => {
        data = data.filter((c) => c.user.id !== currentUser.id);
        this.setState({
          contractsActiveRecent: data.filter((c) => moment().subtract(8, "days").isBefore(c.initialDate)),
        });
        this.setState({ contractsExpiring: data.filter((c) => moment().add(15, "days").isAfter(c.dueDate)) });
      }),
    ]).then(() => this.setState({ loading: false }));
  }

  someHasValue = (arrayOfArray) => arrayOfArray.some((a) => a.length);

  render() {
    const { loading } = this.state;
    const { contractsWaitingSign, contractsWaitingAport, contractsWaitingValidation, contractsWaitingFinalSign, contractsExpiring, contractsWaitingRedeem } = this.state;
    const { contractsActiveRecent, contractsRedeemedWaitingPay, contractsRedeemedPaid } = this.state;

    if (loading)
      return (
        <div style={{ textAlign: "center", width: "100%" }}>
          <CircularProgress style={{ marginTop: "10%" }} />
        </div>
      );

    return (
      <>
        {this.someHasValue([contractsWaitingSign, contractsWaitingAport, contractsWaitingValidation, contractsWaitingFinalSign, contractsExpiring, contractsWaitingRedeem]) && (
          <CardPageItem
            margin={1}
            style={{ marginTop: 16 }}
          >
            <DarkBar text={"app.agent.dashboard.title.requiresAttention"} />
            <ContractCardList
              title="app.agent.dashboard.waitingSignContracts"
              list={contractsWaitingSign}
              dateField="createdAt"
            />
            <ContractCardList
              title="app.agent.dashboard.WaitingAportContracts"
              list={contractsWaitingAport}
              dateField="createdAt"
            />
            <ContractCardList
              title="app.agent.dashboard.WaitingValidationContracts"
              list={contractsWaitingValidation}
              dateField="createdAt"
            />
            <ContractCardList
              title="app.agent.dashboard.waitingFinalSignContracts"
              list={contractsWaitingFinalSign}
              dateField="createdAt"
            />
            <ContractCardList
              title="app.agent.dashboard.finishingContracts"
              list={contractsExpiring}
              dateField="dueDate"
            />
            <ContractCardList
              title="app.agent.dashboard.waitingRedeemContracts"
              list={contractsWaitingRedeem}
              dateField="dueDate"
            />
          </CardPageItem>
        )}

        {this.someHasValue([contractsActiveRecent, contractsRedeemedWaitingPay, contractsRedeemedPaid]) && (
          <CardPageItem
            margin={1}
            style={{ marginTop: 16 }}
          >
            <DarkBar text={"app.agent.dashboard.title.recentActivity"} />
            <ContractCardList
              title="app.agent.dashboard.activeRecentContracts"
              list={contractsActiveRecent}
              dateField="initialDate"
            />
            <ContractCardList
              title="app.agent.dashboard.redeemedWaitingPayContracts"
              list={contractsRedeemedWaitingPay}
              dateField="archiveDate"
            />
            <ContractCardList
              title="app.agent.dashboard.redeemedPaidContracts"
              list={contractsRedeemedPaid}
              dateField="archiveDate"
            />
          </CardPageItem>
        )}
      </>
    );
  }
}

const ContractCardList = ({ title, list, dateField }) => (
  <>
    {list &&
      list.length > 0 &&
      list.map((c) => (
        <Card
          key={c.id}
          elevation={1}
          style={{ marginTop: 8 }}
        >
          <CardActionArea
            component={Link}
            to={"/userContract/" + c.id}
          >
            <CardContent>
              <Typography variant="body2">{c.user.name}</Typography>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="caption"
                  color="textSecondary"
                >
                  C{c.id}
                </Typography>
                <Typography
                  variant="caption"
                  color="textSecondary"
                >
                  <FormattedMessage id={"app.agent.dashboard.contract." + dateField} />{" "}
                  <Moment
                    date={c[dateField]}
                    format="DD/MM/YYYY"
                  />
                </Typography>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div></div>
                <Typography
                  variant="body2"
                  color="primary"
                >
                  <FormattedMessage id={title} />
                </Typography>
              </div>
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
  </>
);

function mapStateToProps(state) {
  return {
    config: state.config,
    currentUser: state.user.user.me,
  };
}

export default compose(connect(mapStateToProps, actions))(ContractsStatusOverview);
